import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectBooking, selectTicketsModalOpen } from "../model"
import { useEffect, useState } from "react"
import { getTickets, ITicket } from "@/shared/api/aviabooking"
import { ErrorType } from "@/shared/types"
import { closeTicketsModal } from "../model/booking-payment-slice"
import { Loader } from "@/shared/ui/loader"
import ArrowRightSvg from '@/shared/assets/images/ArrowRight.svg'

export const BookingTicketsModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectTicketsModalOpen)
    const booking = useAppSelector(selectBooking)
    const [tickets, setTickets] = useState<ITicket[]>([])
    const [ticketsError, setTicketsError] = useState<ErrorType>(null)
    const [ticketsLoading, setTicketsLoading] = useState<boolean>(false)

    const handleClose = () => {
        dispatch(closeTicketsModal())
    }

    const fetchTickets = async () => {
        setTicketsError(null)
        setTicketsLoading(true)
        try {
            const response = await getTickets(booking.booking_id)
            setTickets(response.data.tickets)
        } catch (e) {
            setTicketsError(e.response?.data)
        } finally {
            setTicketsLoading(false)
        }
    }

    useEffect(() => {
        if (isOpen && booking) {
            setTickets([])
            fetchTickets()
        }
    }, [booking, isOpen])

    return (
        <Modal
            isOpen={isOpen}
            title="Ваши билеты"
            onRequestClose={handleClose}
        >
            <div className="flex flex-col gap-3">
                {Boolean(tickets.length) &&
                    <div className="flex flex-col gap-3">
                        {tickets.map((ticket, index) => (
                            <a
                                key={index}
                                href={ticket.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-between px-4 py-2 bg-color-primary text-white rounded cursor-pointer transition"
                            >
                                Билет №{index + 1}
                                <ArrowRightSvg width={20} height={20} />
                            </a>
                        ))}
                    </div>
                }
                {ticketsLoading &&
                    <Loader />
                }
                {ticketsError &&
                    <div>
                        Не удалось загрузить билеты
                    </div>
                }
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button" type="button">
                        Закрыть
                    </button>
                </div>
            </div>
        </Modal>
    )
}